module.exports = __webpack_public_path__ + "static/media/touxiang.a9d6e546.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/touxiang.png
// module id = 1866
// module chunks = 0 1